import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import _map from "lodash/map";
import _union from "lodash/union";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var marketCountries = {
  au: {
    en: {
      language: 'english',
      hrefLang: 'en-AU',
      countryName: 'Australia'
    }
  },
  be: {
    fr: {
      language: 'french',
      hrefLang: 'fr-BE',
      countryName: 'Belgique'
    },
    nl: {
      language: 'dutch',
      hrefLang: 'nl-BE',
      countryName: 'België'
    }
  },
  ca: {
    en: {
      language: 'english',
      hrefLang: 'en-CA',
      countryName: 'Canada (English)'
    },
    fr: {
      language: 'french (canada)',
      hrefLang: 'fr-CA',
      countryName: 'Canada (Français)'
    }
  },
  ch: {
    de: {
      language: 'german',
      hrefLang: 'de-CH',
      countryName: 'Schweiz'
    },
    fr: {
      language: 'french',
      hrefLang: 'fr-CH',
      countryName: 'Suisse'
    }
  },
  de: {
    de: {
      language: 'german',
      hrefLang: 'de-DE',
      countryName: 'Deutschland'
    }
  },
  fr: {
    fr: {
      language: 'french',
      hrefLang: 'fr-FR',
      countryName: 'France'
    }
  },
  nl: {
    nl: {
      language: 'dutch',
      hrefLang: 'nl-NL',
      countryName: 'Nederland'
    }
  },
  nz: {
    en: {
      language: 'english',
      hrefLang: 'en-NZ',
      countryName: 'New Zealand'
    }
  },
  se: {
    sv: {
      language: 'swedish',
      hrefLang: 'sv-SE',
      countryName: 'Sverige'
    }
  },
  uk: {
    en: {
      language: 'english',
      hrefLang: 'en-GB',
      countryName: 'United Kingdom'
    }
  },
  us: {
    en: {
      language: 'english',
      hrefLang: 'en-US',
      countryName: 'United States'
    }
  }
};
export var Market = /*#__PURE__*/function () {
  function Market() {
    _classCallCheck(this, Market);
  }
  _createClass(Market, null, [{
    key: "getAllCountryCodes",
    value:
    /**
     * Get array of all countries.
     */
    function getAllCountryCodes() {
      return Object.keys(Market.countries);
    }

    /**
     * Get array of all languages.
     */
  }, {
    key: "getAllLanguageCodes",
    value: function getAllLanguageCodes() {
      return _union.apply(void 0, _toConsumableArray(_map(Market.countries, function (country) {
        return Object.keys(country);
      })));
    }

    /**
     * Get array of languages for a country.
     * @param {string} countryCode - (i.e. au, be, ca)
     */
  }, {
    key: "getCountryLanguages",
    value: function getCountryLanguages(countryCode) {
      var country = Market.countries[countryCode];
      if (!country) return [];
      var langCodes = Object.keys(country);
      var languages = langCodes.map(function (langCode) {
        return country[langCode].language;
      });
      return languages;
    }

    /**
     * Get array of language codes for a country.
     * @param {string} countryCode - (i.e. au, be, ca)
     */
  }, {
    key: "getCountryLanguageCodes",
    value: function getCountryLanguageCodes(countryCode) {
      return Object.keys(Market.countries[countryCode] || {});
    }

    /**
     * Get country name.
     * @param {string} countryCode - (i.e. au, be, ca)
     * @param {string} languageCode - (i.e. en, fr, nl)
     */
  }, {
    key: "getCountryName",
    value: function getCountryName(countryCode, languageCode) {
      var country = Market.countries[countryCode];
      if (!country) return '';
      return country[languageCode] ? country[languageCode].countryName : '';
    }

    /**
     * Get object of market info.
     * @param {string} countryCode - (i.e. au, be, ca)
     * @param {string} languageCode - (i.e. en, fr, nl)
     */
  }, {
    key: "getMarketInfo",
    value: function getMarketInfo(countryCode, languageCode) {
      var country = Market.countries[countryCode];
      return country[languageCode] || {};
    }

    /**
     * Object of country codes, language, countryName
     */
  }]);
  return Market;
}();
_defineProperty(Market, "countries", marketCountries);